export enum DataState {
    unchanged = 0,
    added = 1,
    modified = 2,
    deleted = 3
}